(function () {
  angular
    .module('specsguardApp')
    .service('buildingAddDataService', buildingAddData);

  buildingAddData.$inject = ['Labels', 'sgAutocompleteHelpers'];

  function buildingAddData (Labels, sgAutocompleteHelpers) {
    const LABELS = Labels;

    this.fieldsObj = {
      name: {
        fieldType: 'input',
        label: LABELS.getLabel('buildingname'),
        datatestid: 'building-name',
        helpKey: 'buildingname',
        required: true
      },
      buildingTemplate: {
        fieldType: 'dropdown',
        helpKey: 'buildingtemplate',
        label: LABELS.getLabel('buildingtype'),
        required: true,
        optionsMapping: {
          displayNameKey: 'name',
          valueKey: 'areaTemplates'
        },
        filter: sgAutocompleteHelpers.filter,
        searchTextChanged: false,
        nonAlphabetical: false
      },
      qualityLevel: {
        fieldType: 'dropdown',
        label: LABELS.getLabel('qualitylevel'),
        required: true,
        optionsMapping: {
          displayNameKey: 'displayName'
        },
        filter: sgAutocompleteHelpers.filter,
        searchTextChanged: false,
        nonAlphabetical: true
      }
    };

    this.infoObj = {
      title: LABELS.getLabel('buildingtypeinformation'),
      targetObjKey: 'buildingTemplate',
      targetObjInfoKey: 'info'
    };

    this.buttons = [
      {
        label: LABELS.getLabel('add'),
        datatestid: 'button-create-project',
        type: 'submit',
        validateForm: true
      }
    ];
  }
})();
